/* tslint:disable */
 
/**
 * PaGu Api
 * Gutschrifterstellung API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const UserRole = {
    None: 'None',
    System: 'System',
    Admin: 'Admin',
    FiBu: 'FiBu'
} as const;

export type UserRole = typeof UserRole[keyof typeof UserRole];



